<template>
    <div
        v-show="!region || !loaded"
        class="splash-screen"
    >
        <div class="splash-screen-content">
            <h1 class="tab-header">
                Community  Profiles
            </h1>
            <h2 class="subheader">
                Healthy Albertans. Healthy Communities. Together.
            </h2>
            <div
                v-if="!region"
                class="tab-description text-block"
            >
                The more diverse the information you gather about your community, the better you are able to understand its assets and challenges. These Local Geographical Area (LGA) community profiles are meant to provide residents, community agencies, and local governments with an overview of the wide array of factors influencing health in their community. The profiles use the most up-to-date information on risk factors and community-based strategies to help individuals and groups take action towards building healthier communities.
            </div>
            <div
                v-show="loading"
                class="data-loading"
            >
                <img src="@/assets/loader.svg"><span class="loading-text">{{ loading }}</span>
            </div>
            <div v-if="!loading && !region">
                <location-search
                    :region-model="regionModel"
                    :placeholder="`enter a postal code or community...  e.g. ${regionModel.defaultRegion}`"
                />
                <button
                    class="get-started-button"
                    @click="getStarted"
                >
                    GET STARTED
                </button>
                <button
                    v-if="locationAvailable"
                    class="use-location-button"
                    @click="useDeviceLocation"
                >
                    {{ $screens.mobile ? `use device location` : `use your device location` }}
                </button>
                <div
                    v-if="regionModel.locationError"
                    class="error"
                >
                    {{ regionModel.locationError }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import RegionModel from '@/model/RegionModel';
import appModel from '@/model/AppModel';
import LocationSearch from './LocationSearch.vue';

export default {
    components: {
        LocationSearch
    },
    props: {
        regionModel: {
            type: RegionModel,
            required: true
        }
    },
    data() {
        return {
            searching: null
        };
    },
    computed: {
        loaded() {
            return appModel.loaded;
        },
        loading() {
            if (!appModel.loaded) {
                return 'loading';
            }
            if (this.regionModel.loading) {
                return this.regionModel.loadingMessage;
            }
            return null;
        },
        region() {
            return this.regionModel.localCode;
        },
        locationAvailable() { return this.regionModel.locationPermission !== 'denied' && this.regionModel.locationPermission !== 'unavailable'; }
    },
    methods: {
        searchForRegion(value) {
            if (value.length < 3) {
                return [];
            }
            return this.regionModel.searchForRegion(value);
        },
        async useDeviceLocation() {
            this.regionModel.tryUseCurrentLocation();
        },
        async getStarted() {
            this.regionModel.useDefault();
        }
    },
};
</script>

<style src="./tabs/common.tab.css" scoped></style>
<style lang="postcss">
.splash-screen .search-container input {
    @apply border border-neutral-input rounded-full p-2 inline-block;
    height: 48px;
}
.splash-screen .search-container {
    @apply  w-2/3 inline-block align-top pt-0;
    border: none;
    height: unset;
}
.splash-screen .search-container .search-icon {
    @apply  pr-6;
    top: 0.4em;
}
</style>
<style lang="postcss" scoped>
.error {
    @apply
        text-red-400
        text-xs
}

.splash-screen {
    /* @apply border-2 border-gray-600; */
    @apply items-center;
    @apply flex flex-row;
    @apply bg-white mx-auto h-content-height;
    max-width: 1400px;
    width: 100vw;
    /* min-height: calc(100vh - 85px); */
}

.splash-screen-content {
    @apply  mx-auto px-2;
    max-width: 800px;
}

.data-loading img {
    @apply  align-bottom;
    max-width: 50px;
    max-height: 50px;
    /* margin: 20px; */
    display: inline-block;
}

.subheader {
    @apply text-primary-4 text-lg font-normal mt-6;
}

.tab-description {
    @apply mb-8;
    max-width: unset;
    width: 100% !important;
}

.loading-text {
    @apply text-neutral-label align-bottom mx-3 inline-block;
}

.use-location-button {
    @apply underline text-primary-4 ml-4 text-sm;
}

.get-started-button {
    @apply w-1/4 border border-secondary-teal whitespace-no-wrap
           rounded-full my-1 bg-secondary-teal text-white align-top;
    margin-left: 7%;
    min-width: 100px;
}

.get-started-button, .use-location-button {
    height: 48px;
}
/* Media breakpoints last if we want them to override defaults */
@screen mobile {
    .splash-screen {
        /* @apply bg-white mx-auto h-content-height; */
        @apply h-auto;
        @apply min-h-screen-sm;
    }
    .use-location-button {
        @apply no-underline uppercase text-neutral-text font-bold;
    }
    .get-started-button, .search-container, .use-location-button {
        @apply block ml-auto mr-auto;
        width: 90%;
    }
}

</style>
